
import React from 'react';
import styled from 'styled-components';

const CheckBox = styled.div`
    padding-top:0.15rem;
    margin-top:-0.2rem;
    margin-left:0.25rem;
    height: 1.1rem;
    width: 1.1rem;
    .container {
        display: block;
        position: relative;
        padding-left: 1.7rem;
        cursor: pointer;
        font-size: 1.0rem;
        font-weight: 500;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    
    .container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 1.1rem;
        width: 1.1rem;
        border-radius:0.2rem;
        box-shadow: var(--button-outline);
        -moz-box-shadow: var(--button-outline);
        -webkit-box-shadow: var(--button-outline);
    }
    .container input:checked ~ .checkmark {
        background-color: var(--main-color);
    }
    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }
    .container input:checked ~ .checkmark:after {
        display: block;
    }
    .container .checkmark:after {
        left: 0.38rem;
        top: 0.05rem;
        width: 0.29rem;
        height: 0.75rem;
        border: solid white;
        border-width: 0 0.13rem 0.13rem 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`


export const CheckBoxInput = ({disabled, checked, onChangeAction, className}) => {
    return <CheckBox> 
        <label className="container">
            <input type="checkbox" disabled={disabled} defaultChecked={checked} 
            onChange={(e)=>{
                if(onChangeAction.method)onChangeAction.method(e.target.checked, onChangeAction.parameter);
            }}  
            className={className}
            />
            <span className="checkmark"></span>
        </label>
    </CheckBox>
    
    // return <CheckBox> 
    //     <input type="checkbox" disabled={disabled} defaultChecked={defaultChecked} />
    // <span className="checkmark"></span>
    // </CheckBox>
}